export default __webpack_public_path__ + "images/RO.7239168.png";